var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "project-container" },
    [
      _c("router-view", { attrs: { name: "Modal" } }),
      _c("div", { staticClass: "project-container-menu" }, [
        _c("div", { staticClass: "project-title-container" }, [
          _c("i", {
            staticClass: "el-icon-back",
            attrs: { title: "返回项目列表" },
            on: {
              click: function($event) {
                return _vm.$router.push("/list?type=1")
              }
            }
          }),
          _c("h4", [_vm._v(_vm._s(_vm.$route.query.projectName))]),
          _vm.projectDetail && _vm.projectDetail.farmArea
            ? _c("h5", { staticStyle: { color: "#fff" } }, [
                _vm._v(
                  " （面积：" + _vm._s(_vm.projectDetail.farmArea) + " km²） "
                )
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "project-item-list" },
          [
            _c(
              "el-collapse",
              { attrs: { value: "1" } },
              [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "方案列表", name: "1" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.checkPlanListIds,
                          callback: function($$v) {
                            _vm.checkPlanListIds = $$v
                          },
                          expression: "checkPlanListIds"
                        }
                      },
                      _vm._l(_vm.planList, function(planItem) {
                        return _c(
                          "div",
                          {
                            key: planItem.planId,
                            staticClass:
                              "project-item-children-item disflex-item",
                            class: {
                              "plan-active":
                                planItem.planId == _vm.curPlanItem.planId
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "disflex-item-right",
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handlePlanCheckChange(planItem)
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    _c("el-checkbox", {
                                      attrs: { label: planItem.planId }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { flex: "1" } },
                                  [
                                    !planItem.edit
                                      ? _c(
                                          "el-button",
                                          {
                                            class: planItem.defaultFlag
                                              ? "default-title"
                                              : "title",
                                            attrs: { type: "text" }
                                          },
                                          [_vm._v(_vm._s(planItem.planName))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                              },
                                              focus: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                              }
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              ref: `plan_${planItem.planId}`,
                                              refInFor: true,
                                              staticStyle: { width: "200px" },
                                              nativeOn: {
                                                keydown: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  return _vm.changeTitle(
                                                    planItem
                                                  )
                                                }
                                              },
                                              model: {
                                                value: planItem.inputName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    planItem,
                                                    "inputName",
                                                    $$v
                                                  )
                                                },
                                                expression: "planItem.inputName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { float: "right" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: planItem.edit,
                                            expression: "planItem.edit"
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.changeTitle(planItem)
                                              }
                                            }
                                          },
                                          [_vm._v("确定")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                planItem.edit = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !planItem.edit,
                                            expression: "!planItem.edit"
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                planItem.economicStatus != 1
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.generateReport(
                                                  planItem
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("报告")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.editName(
                                                  planItem,
                                                  "plan_" + planItem.planId
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("修改")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              disabled:
                                                planItem.defaultFlag == 1
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deletePlanList(
                                                  planItem
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("删除")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "project-item-btn-group" }, [
                      _c(
                        "div",
                        { staticClass: "project-item-btn-item" },
                        [
                          _vm.planList.length > 0
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: () => {
                                      this.planModalVisible = true
                                      this.curPlan = {}
                                    }
                                  }
                                },
                                [_vm._v("创建方案")]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleWindFarmBoundary } },
                            [
                              _c("div", { staticClass: "operate-item" }, [
                                _c("i", {
                                  staticClass: "operate-item-icon resource-icon"
                                }),
                                _c("span", [
                                  _vm._v("风场范围 "),
                                  _c("i", { staticClass: "el-icon-arrow-down" })
                                ])
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "drawWindFarm" } },
                                    [_vm._v("手绘范围")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "importKMZ" } },
                                    [_vm._v("导入KMZ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: "exportKMZ",
                                        disabled: !_vm.showWindfarm
                                      }
                                    },
                                    [_vm._v("导出KMZ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.checkPlanListIds.length > 1
                            ? _c("span", { on: { click: _vm.contrastClick } }, [
                                _vm._v("方案对比")
                              ])
                            : _c("span", { staticClass: "disabled" }, [
                                _vm._v("方案对比")
                              ])
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "project-item-list" },
          [
            _c(
              "el-collapse",
              { attrs: { value: "2" } },
              [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "资源列表", name: "2" } },
                  _vm._l(_vm.itemList, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.itemId,
                        staticClass: "project-item-children-item disflex-item",
                        class: {
                          "plan-active": _vm.currentItem.itemId === item.itemId
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "disflex-item-right",
                            on: {
                              click: function($event) {
                                return _vm.handleItemPointClick1(item)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "20px"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.checkBoxChangeByEye(item)
                                  }
                                }
                              },
                              [
                                item.showCheck
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "vertical-align": "top"
                                      },
                                      attrs: {
                                        src: require("../../asset/zy.png")
                                      }
                                    })
                                  : _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "vertical-align": "top"
                                      },
                                      attrs: {
                                        src: require("../../asset/by.png")
                                      }
                                    })
                              ]
                            ),
                            !item.edit
                              ? _c(
                                  "el-button",
                                  {
                                    class:
                                      item.isdefault == 1 || item.istypical == 1
                                        ? "default-title"
                                        : "title",
                                    attrs: { type: "text" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (item.itemType == "1"
                                          ? "点："
                                          : "面：") + item.itemName
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                      },
                                      focus: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      ref: `item_${item.itemId}`,
                                      refInFor: true,
                                      staticStyle: { width: "200px" },
                                      nativeOn: {
                                        keydown: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.confirmChangeItemName(item)
                                        }
                                      },
                                      model: {
                                        value: item.inputItemName,
                                        callback: function($$v) {
                                          _vm.$set(item, "inputItemName", $$v)
                                        },
                                        expression: "item.inputItemName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _c("span", { staticStyle: { float: "right" } }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.edit,
                                      expression: "item.edit"
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.confirmChangeItemName(item)
                                        }
                                      }
                                    },
                                    [_vm._v("确定")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          item.edit = false
                                        }
                                      }
                                    },
                                    [_vm._v("取消")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.edit,
                                      expression: "!item.edit"
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                [
                                  item.istypical == 0 && item.itemType == "1"
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.handleSetTypicalItem(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("设代表点")]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled: item.isdefault == 1
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.editName(
                                            item,
                                            "item_" + item.itemId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("修改")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled:
                                          item.isdefault == 1 ||
                                          item.istypical == 1,
                                        type: "text"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.deleteWindItem(item)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "project-item-list" },
          [
            _c(
              "el-collapse",
              { attrs: { value: "3" } },
              [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "敏感因素", name: "3" } },
                  [
                    _vm._l(_vm.windfarmExclusiveList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.exclusiveId,
                          staticClass:
                            "project-item-children-item disflex-item",
                          class: {
                            "plan-active":
                              _vm.curWindExclusiveItem.exclusiveId ===
                              item.exclusiveId
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "disflex-item-right",
                              on: {
                                click: function($event) {
                                  return _vm.handleExclusiveClick(item)
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.checkExclusiveChange(item)
                                    }
                                  }
                                },
                                [
                                  item.showCheck
                                    ? _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          "vertical-align": "top"
                                        },
                                        attrs: {
                                          src: require("../../asset/zy.png")
                                        }
                                      })
                                    : _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          "vertical-align": "top"
                                        },
                                        attrs: {
                                          src: require("../../asset/by.png")
                                        }
                                      })
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { display: "inline-block" } },
                                [
                                  !item.edit
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: item.exclusiveName,
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                color: "#ffffff",
                                                width: "120px",
                                                "font-size": "14px",
                                                "padding-top": "5px",
                                                display: "inline-block"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.exclusiveName.substring(
                                                    0,
                                                    6
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                            },
                                            focus: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                            }
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            ref: `exclus_${item.exclusiveId}`,
                                            refInFor: true,
                                            staticStyle: { width: "200px" },
                                            nativeOn: {
                                              keydown: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.confirmChangeExclusiveName(
                                                  item
                                                )
                                              }
                                            },
                                            model: {
                                              value: item.inputName,
                                              callback: function($$v) {
                                                _vm.$set(item, "inputName", $$v)
                                              },
                                              expression: "item.inputName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                  !item.edit
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: item.exclusiveTypeName,
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                color: "#ffffff",
                                                "font-size": "14px",
                                                "padding-top": "5px",
                                                display: "inline-block"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.exclusiveTypeName.substring(
                                                    0,
                                                    6
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticStyle: { float: "right" } },
                                [
                                  item.edit
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.confirmChangeExclusiveName(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("确定")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                item.edit = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.exportExclusiveKMZ(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("导出")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.editName(
                                                  item,
                                                  "exclus_" + item.exclusiveId
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("修改")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.deleteExclusiveItem(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("删除")]
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _c("div", { staticClass: "project-item-btn-group" }, [
                      _c("div", { staticClass: "project-item-btn-item" }, [
                        _c(
                          "span",
                          {
                            class: [
                              "farm-area-button",
                              {
                                "is-active": _vm.toolUIStatus.exclusive
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.handleToolClick("exclusive")
                              }
                            }
                          },
                          [_vm._v("手绘")]
                        ),
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                _vm.exclusiveModalVisible = true
                              }
                            }
                          },
                          [_vm._v("导入")]
                        )
                      ])
                    ])
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("leaflet-map", {
        ref: "l",
        attrs: {
          toolbar: _vm.toolbar,
          toolbarStatus: _vm.toolbarStatus,
          layers: _vm.layers,
          getStyle: _vm.getStyle,
          drawOptions: _vm.drawOptions
        },
        on: {
          "update:toolbarStatus": _vm.handleTriggerTools,
          create: _vm.createEleFn,
          click: _vm.handleElementClick,
          edit: _vm.handleMapInput
        },
        model: {
          value: _vm.mapData,
          callback: function($$v) {
            _vm.mapData = $$v
          },
          expression: "mapData"
        }
      }),
      _vm.activePointItem
        ? _c("PointDetail", {
            attrs: {
              fromProjectList: "",
              title: "点资源：" + (_vm.activePointItem.itemName || "临时点"),
              itemConfig: _vm.activePointItem
            },
            on: {
              "update:itemConfig": function($event) {
                _vm.activePointItem = $event
              },
              "update:item-config": function($event) {
                _vm.activePointItem = $event
              },
              del: _vm.handleDelPointItemClick,
              saveList: _vm.handleSavePointClick,
              handleCloseModalClick: _vm.handleCloseModalClick
            }
          })
        : _vm._e(),
      _vm.activeSpecialPointItem
        ? _c("PointDetail", {
            attrs: {
              className: "tower-detail-point",
              fromProjectList: "",
              title: "测风塔：" + _vm.curTower.towerNo,
              showBottomArea: false,
              itemConfig: _vm.activeSpecialPointItem
            },
            on: {
              "update:itemConfig": function($event) {
                _vm.activeSpecialPointItem = $event
              },
              "update:item-config": function($event) {
                _vm.activeSpecialPointItem = $event
              },
              del: _vm.handleDelPointItemClick,
              saveList: _vm.handleSavePointClick,
              handleCloseModalClick: function($event) {
                _vm.activeSpecialPointItem = null
              }
            }
          })
        : _vm._e(),
      _vm.activeFaceItem
        ? _c("FaceItem", {
            ref: "face",
            attrs: {
              title: "区域资源：" + (_vm.activeFaceItem.itemName || "临时区域"),
              itemConfig: _vm.activeFaceItem
            },
            on: {
              "update:itemConfig": function($event) {
                _vm.activeFaceItem = $event
              },
              "update:item-config": function($event) {
                _vm.activeFaceItem = $event
              },
              updateImg: _vm.updateMapItemsIMG,
              addItem: _vm.addFaceItem,
              deleteItem: _vm.deleteFaceItem,
              handleCloseModalClick: _vm.handleCloseModalClick
            }
          })
        : _vm._e(),
      _c("Tool", {
        attrs: { UIStatus: _vm.toolUIStatus },
        on: {
          mapToolClick: _vm.handleToolClick,
          newWindFarm: _vm.handleNewWindFarm,
          importFile: _vm.handleImportFile
        }
      }),
      _c("downPlanReportModal", {
        attrs: { plan: _vm.reportPlan, visible: _vm.downPlanReportVisible },
        on: { save: _vm.downReport, close: _vm.closeDownPlanReportModal }
      }),
      _vm.planModalVisible
        ? _c("ChangePlanNameModal", {
            attrs: { visible: _vm.planModalVisible, plan: _vm.curPlan },
            on: {
              saveBack: _vm.getPlanList,
              close: function($event) {
                _vm.planModalVisible = false
              }
            }
          })
        : _vm._e(),
      _vm.windModalVisible
        ? _c("ChangeWindNameModal", {
            attrs: { visible: _vm.windModalVisible, item: _vm.curWindItem },
            on: {
              saveBack: _vm.getWindResource,
              close: function($event) {
                _vm.windModalVisible = false
              }
            }
          })
        : _vm._e(),
      _c("uploadBoundaryModal", {
        attrs: { visible: _vm.boundaryImportVisible },
        on: {
          close: _vm.closeBoundaryModal,
          uploadConfirm: _vm.handleBoundarySuccessUpload
        }
      }),
      _vm.windExclusiveModalVisible
        ? _c("ChangeWindExclusiveModal", {
            attrs: {
              visible: _vm.windExclusiveModalVisible,
              item: _vm.curWindExclusiveItem,
              geometryInfo: _vm.createForm.geometryInfo
            },
            on: { close: _vm.handleWindExclusiveClose }
          })
        : _vm._e(),
      _c("ExclusiveUploadModal", {
        attrs: { visible: _vm.exclusiveModalVisible },
        on: {
          close: function($event) {
            _vm.exclusiveModalVisible = false
          },
          uploadConfirm: _vm.handleExcluseSiveSuccess
        }
      }),
      _vm.citySearchVisible
        ? _c("CityLocationSearch", {
            attrs: { regionList: _vm.regionList },
            on: {
              close: () => {
                this.citySearchVisible = false
                this.activeFaceItem = null
              },
              clearPolygonItem: function($event) {
                _vm.activeFaceItem = null
              }
            }
          })
        : _vm._e(),
      _vm.lanlonSearchVisible
        ? _c("LanlonSearch", {
            on: {
              close: function($event) {
                _vm.lanlonSearchVisible = false
              }
            }
          })
        : _vm._e(),
      _vm.isPlanToolShow
        ? _c("PlanTool", {
            attrs: { id: _vm.curPlanItem.planId, plan: _vm.curPlanItem },
            on: { showClick: _vm.handleWindFarmItemClick }
          })
        : _vm._e(),
      _c("CompareTable", {
        attrs: {
          planTableData: _vm.tableContrastData,
          tableOptimalIndex: _vm.tableOptimalIndex,
          isShowContrast: _vm.showWindContrastDialog
        },
        on: {
          closeClick: function($event) {
            _vm.showWindContrastDialog = false
          }
        }
      }),
      _vm.fanPanelVisible
        ? _c("FanPanel", {
            attrs: {
              turbine: _vm.curFan,
              scene: "plan",
              title:
                "风机：" +
                _vm.curFan.turbineNo +
                "（轮毂：" +
                _vm.curFan.height +
                "m）",
              turbineList: _vm.turbineList,
              plan: _vm.curPlanItem
            },
            on: {
              close: function($event) {
                _vm.fanPanelVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }